"use client"
import { FooterSocialDto } from "api"
import { trackFooterClicks } from "common/analytics"
import NextLink from "common/bit/NextLink"
import FacebookIcon from "reusable/icons/FacebookIcon"
import InstagramIcon from "reusable/icons/InstagramIcon"
import YoutubeIcon from "reusable/icons/YoutubeIcon"
import styled from "styled-components"
import colors from "theme/colors"
import { FooterVariant } from "./FooterItem"

const Row = styled.div<{ $variant: FooterVariant }>`
  display: flex;
  align-items: center;
  gap: ${(p) => (p.$variant === "desktop" ? "16px" : "20px")};
  justify-content: ${(p) =>
    p.$variant === "desktop" ? "flex-start" : "center"};
  width: 100%;
  padding: ${(p) => (p.$variant === "desktop" ? "40px 0 24px" : "0")};
  a {
    display: inline-flex;
    height: fit-content;
  }
`

const IconLink = styled.span`
  display: inline-flex;
  svg {
    width: 24px;
    height: 24px;
  }
`

type SocialEntry = {
  key: keyof FooterSocialDto
  url: string
  label: string
  Icon: typeof FacebookIcon
}

type FooterSocialRowProps = {
  social: FooterSocialDto
  variant: FooterVariant
}

const FooterSocialRow = ({ social, variant }: FooterSocialRowProps) => {
  if (!social) return null

  const entries: SocialEntry[] = [
    {
      key: "facebook",
      url: social.facebook,
      label: "facebook",
      Icon: FacebookIcon,
    },
    {
      key: "instagram",
      url: social.instagram,
      label: "instagram",
      Icon: InstagramIcon,
    },
    {
      key: "youtube",
      url: social.youtube,
      label: "youtube",
      Icon: YoutubeIcon,
    },
  ]

  // Empty social URL → icon not shown (DLK-557).
  const visible = entries.filter((entry) => !!entry.url)
  if (!visible.length) return null

  return (
    <Row $variant={variant}>
      {visible.map(({ key, url, label, Icon }) => (
        <NextLink
          key={key}
          href={url}
          openInNewTab
          onClick={() => trackFooterClicks()}
        >
          <IconLink aria-label={label}>
            <Icon color={colors.white} />
          </IconLink>
        </NextLink>
      ))}
    </Row>
  )
}

export default FooterSocialRow
